export default __webpack_public_path__ + "static/media/p3-2.e818b6a2.png";